import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addToCartBookingPaymentMethod,
  emptyPaymentMethod,
} from "../../../redux/features/cartStateBooking"; // ← adjust path
import { FaMoneyBillWave, FaCreditCard, FaGlobe } from "react-icons/fa";

const paymentOptions = [
  {
    value: "cash",
    label: "Cash at Kiosk",
    sub: "Pay with cash at pickup",
    icon: <FaMoneyBillWave className="text-xl" />,
  },
  {
    value: "card",
    label: "Card at Kiosk",
    sub: "Pay with card at pickup counter",
    icon: <FaCreditCard className="text-xl" />,
  },
  {
    value: "online",
    label: "Online Payment",
    sub: "Pay securely online via Stripe",
    icon: <FaGlobe className="text-xl" />,
  },
];

const PaymentMethodSelector = ({ selected, onChange }) => {
  const dispatch = useDispatch();
  const selectedFromRedux =
    useSelector((s) => s.cartBooking?.bookingPaymentMethod) ?? "";

  const current = selected ?? selectedFromRedux;

  const handleSelect = (value) => {
    dispatch(addToCartBookingPaymentMethod(value)); // ✅ add to cart (Redux)
    onChange?.(value); // optional parent sync
  };

  const handleClear = () => {
    dispatch(emptyPaymentMethod());
    onChange?.("");
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold text-text">
          Choose Payment Method
        </h2>
        <button
          type="button"
          onClick={handleClear}
          className="text-xs px-3 py-1 rounded border border-border text-textGray hover:border-textGray"
        >
          Clear
        </button>
      </div>

      <div className="space-y-3">
        {paymentOptions.map((opt) => {
          const isSelected = current === opt.value;
          return (
            <div
              key={opt.value}
              role="button"
              aria-pressed={isSelected}
              onClick={() => handleSelect(opt.value)}
              className={`cursor-pointer border rounded-xl px-4 py-3 flex items-start gap-4 transition
                ${
                  isSelected
                    ? "border-redlight bg-redlight/20"
                    : "border-border hover:border-textGray"
                }`}
            >
              <div className="pt-1">{opt.icon}</div>
              <div>
                <p
                  className={`font-semibold ${
                    isSelected ? "text-redlight" : "text-text"
                  }`}
                >
                  {opt.label}
                </p>
                <p className="text-sm text-textGray">{opt.sub}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PaymentMethodSelector;

// import React from "react";
// import { FaMoneyBillWave, FaCreditCard, FaGlobe } from "react-icons/fa";
// import { useDispatch } from "react-redux";

// const paymentOptions = [
//   {
//     value: "cash",
//     label: "Cash at Kios",
//     sub: "Pay with cash at pickup",
//     icon: <FaMoneyBillWave className="text-xl " />,
//   },
//   {
//     value: "card",
//     label: "Card at Kios",
//     sub: "Pay with card at pickup counter",
//     icon: <FaCreditCard className="text-xl " />,
//   },
//   {
//     value: "online",
//     label: "Online Payment",
//     sub: "Pay securely online by Stripe",
//     icon: <FaGlobe className="text-xl " />,
//   },
// ];

// const PaymentMethodSelector = ({ selected, onChange }) => {
//   const dispatch = useDispatch();
//   return (
//     <div className="space-y-6">
//       <h2 className="text-2xl font-bold text-text">Choose Payment Method</h2>
//       <div>
//         {paymentOptions.map((option, idx) => (
//           <div
//             key={option.value}
//             onClick={() => onChange?.(option.value)}
//             className={`cursor-pointer border rounded-xl px-4 py-3 flex items-start space-x-4 transition mb-4 last:mb-0
//         ${
//           selected === option.value
//             ? "border-redlight bg-redlight"
//             : "border-border hover:border-textGray"
//         }`}
//           >
//             <div className="pt-1">{option.icon}</div>
//             <div>
//               <p className="font-semibold text-text">{option.label}</p>
//               <p className="text-textGray text-sm">{option.sub}</p>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default PaymentMethodSelector;
